import request from '@/utils/request'
import URL from '@/api/urlTranslator'

/**
 * 目的港业务 API（尾程商务 / 海外跟单）
 * 独立于 job.js，专门处理目的港业务的列表查询
 */

// 目的港业务查询【尾程商务、海外跟单】
export function findDestinationBusinessJobs(data) {
  return request({
    url: URL.booking.findDestinationBusinessJobs,
    method: 'post',
    data
  })
}

// 尾程商务-审核通过
// jobKeys: 业务UUID列表（字符串数组），branchId: 分公司ID
export function finalStepAuditPass(jobKeys, branchId) {
  return request({
    url: URL.booking.finalStepAuditPass,
    method: 'post',
    params: { branchId },
    data: jobKeys
  })
}

// 尾程商务-退回
// jobKeys: 业务UUID列表（字符串数组），returnReason: 退回原因
export function finalStepReturn(jobKeys, returnReason) {
  return request({
    url: URL.booking.finalStepReturn,
    method: 'post',
    params: { returnReason },
    data: jobKeys
  })
}
